import Dict from '@/utils/dict-utils'

// 菜单类型
export const menuTypeDict = new Dict({
  DIRECTORY: { label: '目录', value: 1 },
  MENU: { label: '菜单', value: 2 },
  BUTTON: { label: '按钮', value: 3 }
})

// 菜单状态
export const menuStateDict = new Dict({
  NORMAL: { label: '正常', value: 1 },
  FORBIDDEN: { label: '停用', value: 2 }
})

// 数值类型的判断字典
export const menuJudgmentDict = new Dict({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 2 }
})
